import React from 'react';

import { highlightSearch } from '../../../MultiSelect/utils';
import { Wrapper } from './styled';

type Props = {
  text: string;
  action: (e: React.MouseEvent) => void;
  highlightText?: string;
  disabled?: boolean;
};

const ActionCell = ({ text, action, highlightText, disabled }: Props): JSX.Element => {
  return (
    <Wrapper $disabled={disabled} data-testid="actionCell" onClick={action}>
      {highlightSearch(text, highlightText || '')}
    </Wrapper>
  );
};

export default ActionCell;
